import CloseIcon from "@mui/icons-material/Close";
import {
  Alert,
  AlertTitle,
  Box,
  Collapse,
  IconButton,
  Typography,
} from "@mui/material";
import { useState } from "react";
import useColors from "../../../../api/hooks/useColors";
import SvgToIcon from "../../../../icons/SvgToIcon";
import { ReactComponent as MissingControls } from "../../../../icons/icon_files/missing_controls.svg";

const MissingControlsAlert = ({ protectionCategory }) => {
  const [openIntegrationGuideInfo, setIntegrationGuideInfo] = useState(true);
  const colors = useColors();
  return (
    <Collapse sx={{ width: "100%" }} in={openIntegrationGuideInfo}>
      <Alert
        severity="warning"
        icon={
          <Box>
            <SvgToIcon
              style={{ width: "20px", marginTop: "5px" }}
              IconLogo={MissingControls}
            />
          </Box>
        }
        sx={{
          backgroundColor: colors.warning_orange_soft,
          border: "1px solid " + colors.warning_light_orange,
          borderRadius: "8px",

          "& .MuiAlert-message": {
            width: "100%",
          },
        }}
        action={
          <IconButton
            aria-label="close"
            color="inherit"
            size="small"
            sx={{}}
            onClick={() => {
              setIntegrationGuideInfo(false);
            }}
          >
            <CloseIcon fontSize="inherit" />
          </IconButton>
        }
      >
        <AlertTitle
          sx={{
            margin: 0,
          }}
        >
          <Typography variant="subtitle1" sx={{ color: colors.text_primary }}>
            No Controls in Place
          </Typography>
        </AlertTitle>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography
            variant="body2"
            sx={{
              color: colors.text_primary,
            }}
          >
            We advise you to integrate an{" "}
            <strong>{protectionCategory} protection control</strong> to prevent
            potential threats. Without a control in place, this step is actively
            exposing your environment to attacks.
          </Typography>
        </Box>
      </Alert>
    </Collapse>
  );
};

export default MissingControlsAlert;
